import { WorkspaceActivePage } from './components/WorkspaceHeaderNavigation';

export type WorkspaceNavConfig = {
  path: string;
  label: string;
  compactLabel: string;
};

export const WORKSPACE_NAVIGATION_CONFIG: Record<
  WorkspaceActivePage,
  WorkspaceNavConfig | null
> = {
  workspace: {
    path: '/',
    label: '← Back to Dashboard',
    compactLabel: '← Home',
  },
  'ask-hub': {
    path: '/workspace/{id}',
    label: '← Back to Workspace',
    compactLabel: '← Workspace',
  },
  'ask-session': {
    path: '/workspace/{id}/ask-hub',
    label: '← Back to Ask Hub',
    compactLabel: '← Ask',
  },
  documents: {
    path: '/workspace/{id}',
    label: '← Back to Workspace',
    compactLabel: '← Workspace',
  },
  activities: {
    path: '/workspace/{id}',
    label: '← Back to Workspace',
    compactLabel: '← Workspace',
  },
  'prompt-library': {
    path: '/workspace/{id}',
    label: '← Back to Workspace',
    compactLabel: '← Workspace',
  },
};

export const WORKSPACE_PAGE_CONTEXT: Record<
  WorkspaceActivePage,
  { eyebrow: string; showSessionTitle?: boolean } | null
> = {
  workspace: null,
  'ask-hub': { eyebrow: 'Ask' },
  'ask-session': { eyebrow: 'Ask session', showSessionTitle: true },
  documents: { eyebrow: 'Documents' },
  activities: { eyebrow: 'Activities' },
  'prompt-library': { eyebrow: 'Prompt library' },
};

export type BreadcrumbSegment = {
  label: string;
  path?: string;
};

export const buildWorkspaceBreadcrumbs = ({
  workspaceTitle,
  workspaceId,
  activePage,
  sessionTitle,
}: {
  workspaceTitle: string;
  workspaceId: string;
  activePage: WorkspaceActivePage;
  sessionTitle?: string;
}): BreadcrumbSegment[] => {
  const segments: BreadcrumbSegment[] = [
    { label: 'Home', path: '/' },
    { label: workspaceTitle, path: `/workspace/${workspaceId}` },
  ];

  const context = WORKSPACE_PAGE_CONTEXT[activePage];
  if (!context || activePage === 'workspace') {
    return segments;
  }

  if (activePage === 'ask-session') {
    segments.push({ label: 'Ask', path: `/workspace/${workspaceId}/ask-session` });
    segments.push({
      label: sessionTitle?.trim() || 'Session',
    });
    return segments;
  }

  segments.push({
    label: context.eyebrow,
    path:
      activePage === 'ask-hub'
        ? `/workspace/${workspaceId}/ask-session`
        : activePage === 'documents'
          ? `/workspace/${workspaceId}/documents`
          : activePage === 'activities'
            ? `/workspace/${workspaceId}/activities`
            : activePage === 'prompt-library'
              ? `/workspace/${workspaceId}/prompt-library`
              : undefined,
  });

  return segments;
};
